export default function userTransformer(user) {
  return {
    user_id: user?.id ?? '',
    user_type: !user ? '' : user && user.business ? 'B2B' : 'B2C',
    email: user?.email ?? '',
    phone: user?.phone ? user.phone.replace(/\s+/g, '') : '',
    method: user ? 'mail' : '',
    address: transformAddress(user?.address, user?.firstName, user?.lastName),
  }
}

export function userWithLoginStatus(user, loginStatus = 'logged_in') {
  const base = userTransformer(user)

  return {
    login_status: loginStatus,
    ...base,
  }
}

function transformAddress(address = {}, firstName = '', lastName = '') {
  return {
    name: firstName,
    surname: lastName,
    street: address?.street || '',
    no: address?.streetNumber || '',
    city: address?.city || '',
    region: '',
    country: address?.countryAlpha2 || '',
    zip: address?.postcode || '',
  }
}
